(function () {
  let loading = false;

  function sentinel() {
    return document.querySelector('.infinite-scroll-sentinel');
  }

  function checkAndLoad() {
    const s = sentinel();
    if (!s || loading) return;
    const items = document.querySelectorAll('#product-grid .grid__item');
    if (!items.length) return;
    const lastBottom = items[items.length - 1].getBoundingClientRect().bottom;
    if (lastBottom < window.innerHeight + 400) {
      loadNext(s);
    }
  }

  async function loadNext(s) {
    const url = s.dataset.nextUrl;
    if (!url || loading) return;
    loading = true;
    s.classList.add('infinite-scroll-sentinel--loading');

    /* Spacer keeps the page tall while fetching so the user can't scroll
       past the product list into the footer before new items arrive. */
    var spacer = document.createElement('div');
    spacer.style.height = (window.innerHeight * 3) + 'px';
    s.after(spacer);

    try {
      const res = await fetch(url);
      const parsed = new DOMParser().parseFromString(await res.text(), 'text/html');

      const newItems = parsed.querySelectorAll('#product-grid .grid__item');
      const grid = document.querySelector('#product-grid');
      if (grid) newItems.forEach(function (item) { grid.appendChild(item); });

      spacer.remove();

      const next = parsed.querySelector('.infinite-scroll-sentinel');
      if (next && next.dataset.nextUrl) {
        s.dataset.nextUrl = next.dataset.nextUrl;
        loading = false;
        s.classList.remove('infinite-scroll-sentinel--loading');
      } else {
        s.remove();
        window.removeEventListener('scroll', checkAndLoad);
      }
    } catch (err) {
      console.error('[HC scroll] error:', err);
      spacer.remove();
      loading = false;
      s.classList.remove('infinite-scroll-sentinel--loading');
    }
  }

  function init() {
    window.addEventListener('scroll', checkAndLoad, { passive: true });

    var container = document.getElementById('ProductGridContainer');
    if (container) {
      new MutationObserver(function () {
        loading = false;
      }).observe(container, { childList: true });
    }
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
